import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

export async function handleMsalPopupRedirectBridge(): Promise<boolean> {
  if (!hasPotentialMsalResponse(window.location.hash) && !hasPotentialMsalResponse(window.location.search)) {
    return false;
  }

  try {
    await broadcastResponseToMainFrame();
  } catch {
    return true;
  }

  return true;
}

function hasPotentialMsalResponse(urlPart: string): boolean {
  if (urlPart.length <= 1) {
    return false;
  }

  const normalizedUrlPart =
    urlPart.charAt(0) === '#' || urlPart.charAt(0) === '?' ? urlPart.slice(1) : urlPart;
  return new URLSearchParams(normalizedUrlPart).has('state');
}
